import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EmptyMessage = styled.div`
  margin-top: 8px;
  text-align: center;
  font-weight: bold;
`;
